module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_faq.85c315ee.svg";